import React from "react";
import BundlesWrap from "./BundlesWrap";

function Bundles(props) {
    return (
        <>
            <section className="bundles-bg"><BundlesWrap/></section>
        </>
    )
}

export default Bundles;
